import React, { useState, useEffect } from 'react';

interface ModelConfigurationTooltipeProps {
  imageUrl: string,
  tagString: string,
  tooltipPosition: { top: number, left: number },
}

export function ModelConfigurationTooltip(
  {
    imageUrl,
    tagString,
    tooltipPosition,
  } : ModelConfigurationTooltipeProps,
) : JSX.Element {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setShowTooltip(img.width > 255 && img.height > 255);
    };
    img.onerror = () => {
      setShowTooltip(false); // Do not show tooltip if image fails to load
    };
    img.src = imageUrl;
  }, [imageUrl]);

  if (!showTooltip) {
    return <div />;
  }

  return (
    <div
      className="domain-tooltip-image"
      style={{
        position: 'fixed',
        left: `${tooltipPosition.left - 190}px`,
        top: `${tooltipPosition.top}px`,
        padding: '3px',
        backgroundColor: 'white',
        border: '1px solid #000',
        zIndex: 1000,
        width: '285px',
        height: '325px',
      }}
    >
      <img src={imageUrl} alt={tagString} style={{ width: '100%', height: '85%' }} />
      <div
        style={{
          height: '15%', // Remaining height after the image
          display: 'grid',
          placeItems: 'center', // Centers both vertically and horizontally
        }}
      >
        <h3 style={{ margin: 0 }}>{tagString}</h3>
      </div>
    </div>
  );
}
